import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ProjectStatus.css';

class ProjectStatus extends Component {
  configuration = {
    pending: {
      position: 0,
      total: 2,
    },
    in_progress: {
      position: 1,
      total: 2,
    },
  };

  static propTypes = {
    status: PropTypes.shape({
      status: PropTypes.string,
      label: PropTypes.string,
    }),
  };

  render() {
    const { status } = this.props;
    return (
      <div className="project-status">
        <div className={'status-text ' + (status ? status.status : '')}>
          {status ? status.label.toUpperCase() : ''}
        </div>
      </div>
    );
  }
}

export default ProjectStatus;



// WEBPACK FOOTER //
// ./src/components/shared/project-status/ProjectStatus.js